import React from 'react';
import styled from '@emotion/styled';

type Props = {
  href?: string;
  color: string;
  fontWeight?: string;
  children?: React.ReactNode | React.ReactNode[];
};

const StyledLink = styled('a')<Props>`
  color: ${props => props.color};
  text-decoration: none;
  font-weight: ${props => props.fontWeight || 'normal'};
`;

function Link(props: Props) {
  const { color, fontWeight, href, children } = props;

  return (
    <StyledLink color={color} fontWeight={fontWeight} href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </StyledLink>
  );
}

export default React.memo(Link);
